import type { TraditionalDoc } from "./doc";
import type {
  CrosswordDraftPayload,
  ImportResult,
  TraditionalCluesSource,
} from "../../../../../services/admin";

// Adapters entre o doc e os DTOs do backend.

/** Resultado do import (kind 'crossword-traditional') → doc; key = ref do rascunho. */
export function importToDoc(result: ImportResult): TraditionalDoc {
  if (result.kind !== "crossword-traditional") {
    throw new Error(`Import de tipo inesperado: ${result.kind}`);
  }
  const { draft } = result;
  return {
    titulo: result.titulo,
    largura: draft.largura,
    altura: draft.altura,
    casasPretas: draft.casasMortas.map((c) => ({ x: c.x, y: c.y })),
    palavras: draft.palavras.map((p) => ({
      key: p.ref,
      id: null,
      texto: p.texto,
      x: p.x,
      y: p.y,
      direcao: p.direcao,
      chave: p.chave,
    })),
  };
}

/** Jogo salvo → doc; key = `p${id}`. */
export function sourceToDoc(src: TraditionalCluesSource): TraditionalDoc {
  return {
    titulo: src.titulo,
    largura: src.largura,
    altura: src.altura,
    casasPretas: src.casasPretas.map((c) => ({ x: c.x, y: c.y })),
    palavras: src.palavras.map((p) => ({
      key: `p${p.id}`,
      id: p.id,
      texto: p.texto,
      x: p.x,
      y: p.y,
      direcao: p.direcao,
      chave: p.chave,
    })),
  };
}

export function docToCreatePayload(doc: TraditionalDoc): CrosswordDraftPayload {
  return {
    titulo: doc.titulo,
    largura: doc.largura,
    altura: doc.altura,
    tiposDePassatemposId: 1,
    palavras: doc.palavras.map((w) => ({
      ref: w.key,
      texto: w.texto,
      x: w.x,
      y: w.y,
      direcao: w.direcao,
      chave: w.chave.trim(),
    })),
    casasMortas: doc.casasPretas.map((c) => ({
      x: c.x,
      y: c.y,
      visivel: true,
    })),
    casasDestaques: [],
  };
}

export function docToCluesBody(doc: TraditionalDoc): {
  titulo: string;
  chaves: { palavraId: number; chave: string }[];
} {
  return {
    titulo: doc.titulo,
    chaves: doc.palavras.map((w) => {
      if (w.id === null)
        throw new Error(`Palavra "${w.texto}" ainda não foi criada.`);
      return { palavraId: w.id, chave: w.chave.trim() };
    }),
  };
}
